var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.pageUrl)?_c('BaseScreenBIPage',{attrs:{"title":_vm.title,"baseSrc":_vm.pageUrl,"pageData":_vm.pageData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }